export interface User {
    id: number;
    first_name: string;
    last_name: string;
    email: string;
    phone: string;
    company: string;
    tax_number: string;
    registration_number: string;
    default_stock: string;
    default_profit_margin: string;
    bc_payment_code: string;
    default_payment_method: string;
    is_admin: boolean;
    bc_customer_no: string;
    created_at: string;
    note: string;
    shopify_company_id: string;
    shopify_contact_id: string;
    shopify_id: string;
    updated_at: string;
    active: boolean;
    alert_message: string;
    bc_company_number: string;
    logo: string;
    accepts_marketing: boolean;
    use_logo: boolean;
}

export enum PaymentMethod {
    UTANVET = 'UTANVET',
    BANK = 'BANK',
}

export type ProfileFormProps = {
    submitSuccess: () => void;
};

export interface NewsletterRequest extends ProfileRequest {
    accepts_marketing: boolean;
}

export interface NewsletterFormValues extends ProfileFormValues {
    accepts_marketing: boolean;
}

export type ProfileFormValues = {
    emailAddress: string;
    first_name: string;
    last_name: string;
    company: string;
    phone: string;
    tax_number: string;
    default_stock: string;
    default_profit_margin: string;
    use_logo: boolean;
    default_payment_method: PaymentMethod;
};

export type ProfileRequest = {
    first_name: string;
    last_name: string;
    company: string;
    phone: string;
    tax_number: string;
    default_stock: string;
    default_profit_margin: string;
    use_logo?: boolean;
};

export interface NewsletterRequest extends ProfileRequest {
    accepts_marketing: boolean;
}

export interface NewsletterFormValues extends ProfileFormValues {
    accepts_marketing: boolean;
}

export interface AdminUserProfileFormValues extends ProfileFormValues {
    bc_customer_no: string;
    userId: number;
    email: string;
    active: boolean;
    alert_message: string;
}

export interface AdminUserProfileRequest extends ProfileRequest {
    bc_customer_no: string;
    email: string;
    active: boolean;
    alert_message: string;
    default_payment_method: PaymentMethod;
}

export interface AddToCompanyProps {
    first_name: string;
    last_name: string;
    email: string;
    bc_company_number: string;
}

export interface LogoUploadResp {
    logo: string;
}
